/* =========================================================================
   Lisono — Cart drawer behavior + AJAX
   Event delegation (so DOM references survive innerHTML swaps).
   Quantity ± and Remove POST to /cart/change.js; the drawer section is
   refreshed via Shopify's section rendering API (?sections=...).
   ========================================================================= */
(function () {
  "use strict";

  let refreshInFlight = null;

  function isOpen() {
    return document.documentElement.getAttribute("data-cart-open") === "true";
  }

  function closeMenuDrawer() {
    const menuDrawer = document.querySelector("[data-lisono-drawer]");
    const header     = document.querySelector("[data-lisono-header]");
    if (menuDrawer) menuDrawer.setAttribute("data-open", "false");
    if (header)     header.setAttribute("data-menu-open", "false");
    document.documentElement.setAttribute("data-drawer-open", "false");
    document
      .querySelectorAll("[data-lisono-toggle]")
      .forEach((t) => t.setAttribute("aria-expanded", "false"));
  }

  function applyOpenState(state) {
    const drawer = document.querySelector("[data-lisono-cart-drawer]");
    if (drawer) drawer.setAttribute("data-open", state ? "true" : "false");
    document.documentElement.setAttribute("data-cart-open", state ? "true" : "false");
    document
      .querySelectorAll("[data-lisono-cart-toggle]")
      .forEach((t) => t.setAttribute("aria-expanded", state ? "true" : "false"));
  }

  function setOpen(next) {
    applyOpenState(next);
    if (next) {
      closeMenuDrawer();
      // Pull the latest cart state in case items were added elsewhere.
      refreshCartSection();
    }
  }

  async function refreshCartSection() {
    if (refreshInFlight) return refreshInFlight;
    refreshInFlight = (async () => {
      try {
        const res = await fetch("/?sections=lisono-cart-drawer", {
          headers: { Accept: "application/json" }
        });
        if (!res.ok) {
          console.warn("[lisono-cart] section fetch failed", res.status);
          return;
        }
        const data = await res.json();
        const html = data["lisono-cart-drawer"];
        if (!html) {
          console.warn("[lisono-cart] section response missing 'lisono-cart-drawer' key", data);
          return;
        }
        const sectionEl = document.getElementById("shopify-section-lisono-cart-drawer");
        if (!sectionEl) {
          console.warn("[lisono-cart] #shopify-section-lisono-cart-drawer not in DOM");
          return;
        }
        const wasOpen = isOpen();
        sectionEl.innerHTML = html;
        applyOpenState(wasOpen);
      } catch (err) {
        console.error("[lisono-cart] refresh error", err);
      } finally {
        refreshInFlight = null;
      }
    })();
    return refreshInFlight;
  }

  async function changeCart(line, quantity) {
    const drawer = document.querySelector("[data-lisono-cart-drawer]");
    if (drawer) drawer.classList.add("is-busy");
    try {
      const res = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: line, quantity: quantity })
      });
      if (!res.ok) throw new Error("cart-change " + res.status);
      const cart = await res.json();

      // Update the basket-pill count in the header section.
      const countEl = document.querySelector("[data-cart-count]");
      if (countEl) countEl.textContent = cart.item_count;

      // Swap the drawer markup with the freshly rendered version.
      await refreshCartSection();
    } catch (err) {
      console.error("[lisono-cart]", err);
    } finally {
      const d = document.querySelector("[data-lisono-cart-drawer]");
      if (d) d.classList.remove("is-busy");
    }
  }

  document.addEventListener("click", (e) => {
    const toggle = e.target.closest("[data-lisono-cart-toggle]");
    if (toggle) {
      if (toggle.tagName === "A") e.preventDefault();
      setOpen(!isOpen());
      return;
    }

    const backdrop = e.target.closest("[data-lisono-cart-backdrop]");
    if (backdrop) {
      setOpen(false);
      return;
    }

    const qtyBtn = e.target.closest("[data-lisono-cart-qty]");
    if (qtyBtn && !qtyBtn.disabled) {
      e.preventDefault();
      const line = parseInt(qtyBtn.dataset.line, 10);
      const quantity = parseInt(qtyBtn.dataset.quantity, 10);
      if (Number.isFinite(line) && Number.isFinite(quantity) && quantity >= 0) {
        changeCart(line, quantity);
      }
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && isOpen()) {
      setOpen(false);
      const firstToggle = document.querySelector("[data-lisono-cart-toggle]");
      if (firstToggle) firstToggle.focus();
    }
  });
})();
